import { Typography } from "@mui/material";
import { DefaultCard, PageLayout } from "components";
import React from "react";

function GalleryPage() {
  return (
    <PageLayout>
      <DefaultCard title="Gallery">
        <Typography variant="h4">Coming Soon</Typography>
      </DefaultCard>
    </PageLayout>
  );
}

export default GalleryPage;
